<template>
<div class="contact-view-files card ">
    <q-uploader
        class="w-100"
        color="white"
        text-color="blue-grey-8"
        label="Auto Uploader"
        ref="uploaderRef"
        flat
        :auto-upload="!props.readOnly"
        with-credentials
        field-name="file"
        max-file-size="5000000"
        :form-fields="formFields"
        :headers="authHeaders"
        :url="endpoint"
        @failed="onUploadFailed"
        @uploaded="onUploaded"
        @rejected="onUploadRejected"
        multiple
    >
        <template v-slot:header="scope">
            <div class="row no-wrap items-center q-pa-md q-gutter-xs" v-if="! props.readOnly">
                <q-btn v-if="scope.queuedFiles.length > 0" icon="clear_all" @click="scope.removeQueuedFiles" round dense flat >
                    <q-tooltip>Clear All</q-tooltip>
                </q-btn>
                <q-btn v-if="scope.uploadedFiles.length > 0" icon="done_all" @click="scope.removeUploadedFiles" round dense flat >
                    <q-tooltip>Remove Uploaded Files</q-tooltip>
                </q-btn>
                <q-spinner v-if="scope.isUploading" class="q-uploader__spinner" />
                <div class="col">
                    <div class="q-uploader__title"><span class="h5 text-blue-grey-10">Files</span></div>
                    <div class="q-uploader__subtitle" v-show="scope.files.length > 0">{{ scope.uploadSizeLabel }} / {{ scope.uploadProgressLabel }}</div>
                </div>
                <q-btn v-if="scope.canAddFiles" icon="add_box" @click="scope.pickFiles" round dense flat>
                    <q-uploader-add-trigger />
                    <q-tooltip>Pick Files</q-tooltip>
                </q-btn>
                <q-btn v-if="scope.canUpload" icon="cloud_upload" @click="scope.upload" round dense flat >
                    <q-tooltip>Upload Files</q-tooltip>
                </q-btn>

                <q-btn v-if="scope.isUploading" icon="clear" @click="scope.abort" round dense flat >
                    <q-tooltip>Abort Upload</q-tooltip>
                </q-btn>
            </div>
        </template>
        <template v-slot:list="scope">
            <q-list separator>
                <q-item v-for="file in scope.files" :key="file.__key">
                    <q-item-section>
                        <q-item-label class="full-width ellipsis">
                            {{ file.name }}
                        </q-item-label>

                        <q-item-label caption>
                            Status: {{ file.__status }}
                        </q-item-label>

                        <q-item-label caption>
                            {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                        </q-item-label>
                    </q-item-section>

                    <q-item-section
                        v-if="file.__img"
                        thumbnail
                        class="gt-xs"
                    >
                        <img :src="file.__img.src">
                    </q-item-section>

                    <q-item-section top side v-if="false">
                        <q-btn
                            class="gt-xs"
                            size="12px"
                            flat
                            dense
                            round
                            icon="delete"
                            @click="scope.removeFile(file)"
                        />
                    </q-item-section>
                </q-item>

            </q-list>
        </template>
    </q-uploader>
    <div>
        <div class="card-body border-top p-1">
            <div class="row no-gutters ">
                <div class="col-lg-6 p-2" v-for="file in attachments">
                    <entry-file :file="file" :key="`file_${file.id}`"
                                :read-only="props.readOnly"
                                @deleted="load" @updated="load" />
                </div>
                <div class="col-lg-4 p-3" v-if="attachments.length === 0">
                    <div v-if="! listLoading">
                        No files uploaded yet
                    </div>
                    <div v-else>
                        <q-skeleton type="rect"/>
                        <q-skeleton type="text"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
import { useQuasar } from 'quasar'
import {onMounted, defineProps, ref, computed} from "vue";
import utils from "../blocks/_utils";
import EntryFile from "./EntryFile";

const $q = useQuasar()

const props = defineProps({
    contactId: Number,
    readOnly: Boolean
})

const uploaderRef = ref(null)
const listLoading = ref(false)

const attachments = ref([]) // {id, content_type, created_at, file_size, file_name, disk_name, path, title, description}

const formFields = [{name: 'field', value: 'attachments'}];

const endpoint = computed(() => window['APIv2'].endpoint + `contact/upload/${ props.contactId }`)
const authHeaders = computed(() => {
    return [{
        name: 'x-user-token',
        value: window['APIv2'].token
    },{
        name: 'x-api-key',
        value: window['APIv2'].key
    }]
})

const {formatFileSize} = utils

const updateFromResponse = (response) => {
    console.log(response)
    const contact = response.contact;
    attachments.value = contact.attachments
}

const load = () => {
    listLoading.value = true;

    console.log(props.contactId)

    window['APIv2']._request(`contact/view/${props.contactId}`).then(updateFromResponse).catch((err) => {
        console.log(err)

    })
        .finally(() => {
            listLoading.value = false;
        })
};

onMounted(() => {
    load()
});

const onUploadRejected = (rejectedEntries) => {
    rejectedEntries.forEach(entry => {

        let errText = 'Undefined error with file ' + entry.file.name

        switch (entry.failedPropValidation){
            case 'accept':
                errText = `Error with ${entry.file.name}: ` + 'Type is unsupported: ' + entry.file.type
                break;
            case 'max-file-size':
                errText = `Error with ${entry.file.name}: ` + 'File size is too large (5MB max)'
                break;
        }

        $q.notify({
            type: 'negative',
            message: errText,
        })
    })
}

const onUploadFailed = (info) => {
    $q.notify({
        type: 'negative',
        message: info.xhr.responseText,
    })
}

const onUploaded = (info) => {
    $q.notify({
        type: 'positive',
        message: 'File uploaded successfully',
    })

    uploaderRef.value.removeUploadedFiles()

    updateFromResponse(JSON.parse(info.xhr.response))
}

</script>

<style scoped>

</style>
